import useScreenSize from './useScreenSize';
import { isReactDesktopPage } from '../utils/helpers/isReactDesktopPage';
import { useClient } from './useClient';

export const useReactPage = (fullUrl: string): boolean => {
  const isClient = useClient();
  const { isSmall } = useScreenSize();

  if (!isClient || !fullUrl) return false;

  return isSmall || isReactDesktopPage(fullUrl);
};
